import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtDate, rupees } from "@/lib/planDisplay";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SRC = { payment: "Paid online", admin: "By admin", partner: "Teacher Utility ToolKit", trial: "Free trial", auto_setup: "After setup" };

// Admin: plan name · source · valid till · days left, plus the school's plan history.
export const AdminPlanInfo = ({ u }) => {
  const [rows, setRows] = useState(null);
  const open = () => axios.get(`${API}/admin/users/${u.id}/plan-history`).then((r) => setRows(r.data.history)).catch(() => toast.error("Could not load plan history"));
  const ms = u.activeUntil ? Date.parse(u.activeUntil) - Date.now() : null;
  const days = ms !== null && ms > 0 ? Math.ceil(ms / 86400000) : null;
  return (
    <div className="mt-1 text-[0.7rem] text-ink-700" data-testid={`admin-plan-info-${u.udiseCode}`}>
      {u.planLabel && <span className="font-semibold text-ink-900">{u.planLabel}</span>}
      {u.planLabel && u.activationSource && <> · {SRC[u.activationSource] || ""}</>}
      {u.activeUntil && <> · {ms > 0 ? "Valid till" : "Expired"} {fmtDate(u.activeUntil)}</>}
      {days !== null && <> · {days} days left</>}
      <button type="button" onClick={open} className="ml-1 font-semibold text-moss-dark hover:underline" data-testid={`admin-plan-history-btn-${u.udiseCode}`}>Plan history</button>
      <Dialog open={rows !== null} onOpenChange={(o) => !o && setRows(null)}>
        <DialogContent className="max-w-lg" data-testid="admin-plan-history-dialog">
          <DialogHeader><DialogTitle>Plan history · {u.schoolName}</DialogTitle></DialogHeader>
          {rows?.length === 0 && <p className="text-sm text-ink-700">No plan history recorded.</p>}
          <ul className="max-h-[60vh] space-y-2 overflow-y-auto">
            {(rows || []).map((h) => (
              <li key={h.id} className="rounded-lg border border-border p-2 text-xs" data-testid={`admin-plan-history-row-${h.id}`}>
                <b>{h.event === "activation" ? h.planLabel : `${h.eventLabel}${h.planLabel ? ` · ${h.planLabel}` : ""}`}</b> · {fmtDate(h.createdAt)}
                <div className="text-ink-700">
                  {h.amountRupees > 0 && <>{rupees(h.amountRupees)} · </>}{h.validityDays ? `${h.validityDays} days · ` : ""}{SRC[h.source] || ""}
                  {h.activeUntil && <> · till {fmtDate(h.activeUntil)}</>}{h.paymentIdMasked && <> · <span className="font-mono">{h.paymentIdMasked}</span></>}
                  {h.receiptNo && <> · {h.receiptNo}</>}
                </div>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
    </div>
  );
};
